import { useEffect } from 'react';
import noop from 'lodash-es/noop';
import type { StorageKey } from './model/StorageKey';

type LocalStoragePubSubSubscriber = (value: string) => void | Promise<void>;

type LocalStoragePubSubPublisher = (value: string) => void;

export const useLocalStoragePubSub = (
    key: StorageKey,
    subscribe?: LocalStoragePubSubSubscriber,
): LocalStoragePubSubPublisher => {
    useEffect(() => {
        const handler = (event: StorageEvent): void => {
            if (event.key === key && typeof subscribe === 'function') {
                const result = subscribe(event.newValue ?? '');
                if (result instanceof Promise) {
                    result.then(noop).catch(noop);
                }
            }
        };
        window.addEventListener('storage', handler);
        return () => {
            window.removeEventListener('storage', handler);
        };
    }, [subscribe, key]);
    return (value: string) => {
        window.localStorage.setItem(key, value ?? '');
    };
};
